import { ShoppingBag, Users, Award, FileCheck, TrendingUp } from "lucide-react";
import { toast } from "sonner";
import { SHOP_URL, scrollToId } from "@/lib/config";

const comingSoon = (what) => () =>
  toast.info(`${what} opens with the pilot episode. Hail the crew at crew@captainscut.com`);

const PILLARS = [
  { name: "SHOP", icon: ShoppingBag, testId: "footer-nav-shop", action: "shop" },
  { name: "COMMUNITY", icon: Users, testId: "footer-nav-community", action: "#community" },
  { name: "VOTE", icon: Award, testId: "footer-nav-vote", action: "#community" },
  { name: "APPLY", icon: FileCheck, testId: "footer-nav-apply", action: "#apply" },
  { name: "INVEST", icon: TrendingUp, testId: "footer-nav-invest", action: comingSoon("Investor relations") },
];

export const Footer = () => (
  <footer className="border-t border-[#D4AF37]/20 bg-[#05070B]" data-testid="footer">
    <div className="max-w-7xl mx-auto px-5 md:px-8 py-16">
      <div className="grid grid-cols-3 md:grid-cols-5 gap-8">
        {PILLARS.map(({ name, icon: Icon, testId, action }) => {
          const inner = (
            <>
              <Icon size={22} className="text-[#D4AF37] group-hover:scale-110 transition-transform duration-300" />
              <span className="text-[10px] tracking-[0.35em] text-[#94A3B8] group-hover:text-[#E8C15A] transition-colors duration-300">
                {name}
              </span>
            </>
          );
          const cls = "group flex flex-col items-center gap-3";
          return action === "shop" ? (
            <a key={name} href={SHOP_URL} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId}>
              {inner}
            </a>
          ) : typeof action === "string" ? (
            <button key={name} onClick={() => scrollToId(action)} className={cls} data-testid={testId}>
              {inner}
            </button>
          ) : (
            <button key={name} onClick={action} className={cls} data-testid={testId}>
              {inner}
            </button>
          );
        })}
      </div>

      <div className="flex items-center gap-6 mt-16">
        <span className="flex-1 h-px bg-gradient-to-r from-transparent to-[#D4AF37]/40" />
        <p className="font-display text-sm md:text-base tracking-[0.3em] gold-text whitespace-nowrap" data-testid="footer-crest">
          CAPTAIN'S CUT<span className="align-super text-[8px]">TM</span>
        </p>
        <span className="flex-1 h-px bg-gradient-to-l from-transparent to-[#D4AF37]/40" />
      </div>
      <p className="text-center font-coords text-[10px] tracking-[0.4em] text-[#94A3B8] mt-6" data-testid="footer-tagline">
        OCEAN MINDED · COMMUNITY DRIVEN · A HIGHER STANDARD
      </p>
      <p className="text-center text-[10px] tracking-[0.25em] uppercase text-[#94A3B8]/70 mt-4">
        <a href="/privacy" className="hover:text-[#E8C15A] transition-colors underline underline-offset-4" data-testid="footer-privacy-link">Privacy Policy</a>
        <span className="mx-3">·</span>
        <a href="mailto:david@captains-cut.com" className="hover:text-[#E8C15A] transition-colors" data-testid="footer-contact-link">david@captains-cut.com</a>
      </p>
    </div>
  </footer>
);
